import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { DOCUMENT_CONTENT_TYPE_PDF, DOCUMENT_TYPE_SURETY_BONDS } from "../../../../../app/constants";
import { convertFileDataForUrl } from "../../../../../app/documentUploadUtils";
// import { convertFileDataForUrl } from "../../../../../app/utils";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../../../../components/DocumentViewer/DocumentFileComponent";
import DocumentViewer from "../../../../../components/DocumentViewer/DocumentViewer";
import { LineSeperator } from "../../../../../components/RegularComponents";
import { fetchDocumentData } from "../../../../../redux/slice/supportingDocumentsSlice";
import { SuretyBondFileUpload } from "./SuretyBondFileUpload";

export const SuretyBondTab = (props) => {
    const { 
        documents, 
        licenceApplication, 
        applicationType, 
        applicationMode, 
        isArchiveApplication 
    } = props
    const dispatch = useDispatch()
    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
    const [selectedFile,setSelectedFile] = useState(null)

    const { suretyBondDocs} = useMemo(() => {
        const suretyBondDocs = []
        licenceApplication.documents.forEach((document) => {
             if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                suretyBondDocs.push(document)
            }
        })
        return { suretyBondDocs}
    }, [licenceApplication.documents])

    const fileComponent = (file, index) => {

        return (
            <>
                <div className="col-8 suretyBondFileContentWrapper">
                    <span className="fileName">
                        {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                            <DocumentViewerFileNameLink
                                id={`surety-bond-information-tab-view-file-${index}-${file.filename}`}
                                key={`surety-bond-information-tab-view-file-${index}-${file.filename}`}
                                file={file}
                                onClick={() => { 
                                    if(file.data) { 
                                        let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                        setDocumentViewerDocument(fileDataUrl)
                                        setOpenDocumentViewer(true)
                                        setSelectedFile(file)
                                    } else { 
                                        // download data and then view it.
                                        if(file.guid) { 
                                            dispatch(fetchDocumentData(file.guid))
                                                .then(downloadFile => {
                                                    if(downloadFile) { 
                                                        let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                        setDocumentViewerDocument(fileDataUrl)
                                                        setOpenDocumentViewer(true)
                                                        setSelectedFile(downloadFile)
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.error(error)
                                                })
                                        }
                                        
                                    }
                                }}
                            /> : 
                            <DownloadFileNameLink
                                id={`surety-bond-information-tab-view-file-${index}-${file.filename}`}
                                componentKey={`surety-bond-information-tab-view-file-${index}-${file.filename}`}
                                file={file} 
                            />
                        }
                    </span>
                </div>

                <DocumentViewer 
                    fileData={documentViewerDocument}
                    isOpen={openDocumentViewer}
                    fileName={selectedFile?.filename}
                    handleClose={() => setOpenDocumentViewer(false)}
                />
            </>
        )
    }

    return (
        <div className="licence-application-details-panel">
            {suretyBondDocs.map((suretyBondDoc, index) => (
                <>
                    <div key={index} className="row section-row-margin">
                        <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                            {index === 0 && <span>Surety bond</span>}
                        </div>

                        <div className="collector-licence-col col-md-8" style={{ display: "flex" }}>
                            {fileComponent(suretyBondDoc, index)}
                        </div>
                    </div>

                    {index === suretyBondDocs.length - 1 ? <LineSeperator /> : null}
                </>
            ))}
            {!isArchiveApplication && <SuretyBondFileUpload 
                licenceApplication={licenceApplication} 
                documents={documents} 
                applicationMode={applicationMode} 
                applicationType={applicationType} 
            />}
        </div>
    )
}